module.exports = __webpack_public_path__ + "Logo.1f1eb1da.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/Logo.png
// module id = Oq+R
// module chunks = 0